import React from "react";

const Textarea = ({name, placeholder, rows, isRequired}) => {
	return <textarea name={name} placeholder={placeholder} rows={rows} required={isRequired} className='w-full p-4 rounded-md bg-gray-100 focus:outline-none focus:ring-1 focus:ring-tad-primary focus:ring-opacity-50'></textarea>;
};

export default Textarea;
